import Model from '../Model';
import Mithril from 'mithril';
import UserLevel from './UserLevel';

export default class LevelConf extends Model {
  levelImg() {
    return Model.attribute<string>('levelImg').call(this);
  }
  color() {
    return Model.attribute<string>('color').call(this);
  }
  level() {
    return Model.attribute<number>('level').call(this);
  }
  addSignInExp() {
    return Model.attribute<number>('addSignInExp').call(this);
  }
  addPostExp() {
    return Model.attribute<number>('addPostExp').call(this);
  }
  addReplyExp() {
    return Model.attribute<number>('addReplyExp').call(this);
  }
  experienceUpperLimit() {
    return Model.attribute<number>('experienceUpperLimit').call(this);
  }
  upgradeExperience() {
    return Model.attribute<number>('upgradeExperience').call(this);
  }
  addSignInIntegra() {
    return Model.attribute<number>('addSignInIntegra').call(this);
  }
  addPostIntegra() {
    return Model.attribute<number>('addPostIntegra').call(this);
  }
  addReplyIntegra() {
    return Model.attribute<number>('addReplyIntegra').call(this);
  }
  userLevel() {
    return Model.hasMany<UserLevel>('userLevel').call(this);
  }


  


  /**
   * Update the user's preferences.
   */
  // savePreferences(newPreferences: Record<string, unknown>): Promise<this> {
  //   const preferences = this.preferences();

  //   Object.assign(preferences ?? {}, newPreferences);

  //   return this.save({ preferences });
  // }
}
